import React, { useState, useEffect } from "react";
import { colors } from "../../../../../themes/Colors";
import {
  BaseButtons,
  TabButtonFlatButton,
} from "../../../../common-components";
import NotificationCard from "../../../components/notifications/notification-card/NotificationCard";
import { BuzzCard } from "../../../components";
import SearchBar from "../../../../common-components/search-bar/SearchBar";
import { CreatePostModal } from "../../../../admin/components/buzz-feed-control-display/components";
import { CreatePostPcPopUp } from "./components";

const BuzzPcDisplay = ({
  setLoading,
  setPopUpTitle,
  setToastPop,
  setMessage,
  setRefresh,
  refresh,
  auth,
  liveFeed,
  historyFeed,
}) => {
  const [tableDisplay, setTableDisplay] = useState("today");
  const [createPostPopUp, setCreatePostPopUp] = useState(false);
  const checkLayout = () => {
    let liveFeedDateSort = liveFeed.sort(
      (a, b) =>
        new Date(...a.editedOn.split("/").reverse()) -
        new Date(...b.editedOn.split("/").reverse())
    );
    liveFeedDateSort = liveFeedDateSort.reverse();
    return liveFeedDateSort;
  };

  const checkLayoutHistory = () => {
    let liveFeedDateSort = historyFeed.sort(
      (a, b) =>
        new Date(...a.editedOn.split("/").reverse()) -
        new Date(...b.editedOn.split("/").reverse())
    );
    liveFeedDateSort = liveFeedDateSort.reverse();
    return liveFeedDateSort;
  };

  const postTypeSplit = (postType) => {
    const splitArray = postType.split(",");

    return splitArray;
  };

  const tagsSplit = (tags) => {
    const splitArray = tags.split(",");

    return splitArray;
  };
  // useEffect(() => {}, [tableDisplay, refresh]);
  return (
    <div
      style={{
        height: "88%",
        maxHeight: 900,
        minHeight: 450,
        width: "94%",
        minWidth: 500,
        maxWidth: 1500,
        backgroundColor: colors.secondaryGrey,
        marginTop: 20,
        borderRadius: 20,
        marginLeft: 5,
        WebkitBoxShadow: "-2px 20px 40px -10px #000000",
        borderStyle: "solid",
        borderWidth: 4,
        borderColor: colors.white,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        overflow: "hidden",
        position: "relative",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          position: "absolute",
          right: 10,
          top: 10,
          zIndex: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <SearchBar marginTop={-12.5} />
        <div style={{ width: 20 }} />

        <BaseButtons
          label={"+ CREATE POST"}
          borderRadius={8}
          backgroundColor={colors.greenLight}
          onClick={() => setCreatePostPopUp(true)}
        />
      </div>
      <div style={{ position: "fixed", top: 35, display: "flex", zIndex: 2 }}>
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"TODAY"}
            backgroundColor={
              tableDisplay === "today" ? colors.greenLight : colors.white
            }
            textColor={
              tableDisplay === "today" ? colors.white : colors.greenDark
            }
            onClick={() => setTableDisplay("today")}
          />
        </div>
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"FOR YOU"}
            backgroundColor={
              tableDisplay === "forYou" ? colors.greenLight : colors.white
            }
            textColor={
              tableDisplay === "forYou" ? colors.white : colors.greenDark
            }
            onClick={() => setTableDisplay("forYou")}
          />
        </div>
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"HISTORY"}
            backgroundColor={
              tableDisplay === "history" ? colors.greenLight : colors.white
            }
            textColor={
              tableDisplay === "history" ? colors.white : colors.greenDark
            }
            onClick={() => setTableDisplay("history")}
          />
        </div>
      </div>
      <div style={{ height: 60 }} />
      <div
        style={{
          height: "90%",
          width: "100%",

          overflowY: "scroll",
          overflowX: "hidden",
          scrollbarWidth: "none",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {tableDisplay === "today"
          ? liveFeed
            ? checkLayout().map((post, index) => {
                return (
                  <div key={index} style={{ width: 330 }}>
                    <BuzzCard
                      buzzTitle={post.title}
                      senderTitle={post.senderDetails}
                      quickDescription={post.shortDescription}
                      longDescription={post.longDescription}
                      postType={postTypeSplit(post.postType[0])[0]}
                      subPostType={postTypeSplit(post.postType[0])[1]}
                      sourceLink={post.sourceLink}
                      tagsData={tagsSplit(post.tags[0])}
                      option2={true}
                      postId={post.postId}
                    />
                  </div>
                );
              })
            : null
          : null}
        {tableDisplay === "history"
          ? historyFeed
            ? checkLayoutHistory().map((post, index) => {
                return (
                  <div key={index} style={{ width: 330 }}>
                    <BuzzCard
                      buzzTitle={post.title}
                      senderTitle={post.senderDetails}
                      quickDescription={post.shortDescription}
                      longDescription={post.longDescription}
                      postType={postTypeSplit(post.postType[0])[0]}
                      subPostType={postTypeSplit(post.postType[0])[1]}
                      sourceLink={post.sourceLink}
                      tagsData={post.tags}
                      option2={true}
                      postId={post.postId}
                    />
                  </div>
                );
              })
            : null
          : null}
      </div>
      <CreatePostPcPopUp
        display={createPostPopUp}
        setLoading={setLoading}
        setMessage={setMessage}
        setPopUpTitle={setPopUpTitle}
        setRefresh={setRefresh}
        refresh={refresh}
        setToastPop={setToastPop}
        setPostRequestModal={setCreatePostPopUp}
        auth={auth}
      />
    </div>
  );
};

export default BuzzPcDisplay;
